import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';

import * as myConstClass from '../../shared/constants/constants';
import AutoSuggestPlayer from '../../shared/AutoSuggest/AutoSuggestPlayer';

const CST_CHART_HEIGHT = 300;
const CST_CHART_TYPES = ['Moyenne', 'IPS', '% de Victoires', 'Facteur de Puissance'];

const NO_OPPONENT_ID = '-1';

class DashMod_Evol01 extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			playerId: 0,
			playerName: '',
			playerData: [],

			dateA: '',
			prevValidDateA: '',
			dateB: '',
			prevValidDateB: '',

			chartType: 1,						// IPS, Moyenne, % vic
			opponentId: NO_OPPONENT_ID,
			opponentName: '',
			opponentData: [],
			statsType: 'monthly',		// daily, weekly, monthly, yearly

			chartData: {},
			chartOptions: {},
			loading: true
		};
	
		this.handleEvolPredefined = this.handleEvolPredefined.bind(this);
		this.handleDateAChange = this.handleDateAChange.bind(this);
		this.handleDateBChange = this.handleDateBChange.bind(this);
		this.handleDateABlur = this.handleDateABlur.bind(this);
		this.handleDateBBlur = this.handleDateBBlur.bind(this);
		this.handleOpponentChange = this.handleOpponentChange.bind(this);
		this.handleSelchartTypeChange = this.handleSelchartTypeChange.bind(this);
		this.handleSelStatsTypeChange = this.handleSelStatsTypeChange.bind(this);
		
	}

	componentDidMount() {
    // console.log('DashMod01: componentDidMount');
		this.initSavedParametersAndLoadData(this.props);
	}

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log('DashMod01: UNSAFE_componentWillReceiveProps');
		this.initSavedParametersAndLoadData(nextProps);
  }

  initSavedParametersAndLoadData(props) {
		var dateA = '';
		var dateB = '';
		var chartType = 0;
		var opponentId = NO_OPPONENT_ID;
		var statsType = 'monthly';

		if (sessionStorage.getItem('statelo-db-evol-dateA') !== null) {
			dateA = sessionStorage.getItem('statelo-db-evol-dateA');
		}
		if (sessionStorage.getItem('statelo-db-evol-dateB') !== null) {
			dateB = sessionStorage.getItem('statelo-db-evol-dateB');
		}
		if (sessionStorage.getItem('statelo-db-evol-chartType') !== null) {
			chartType = parseInt(sessionStorage.getItem('statelo-db-evol-chartType'), 10);
		}
		if (sessionStorage.getItem('statelo-db-evol-opponentId') !== null) {
			opponentId = sessionStorage.getItem('statelo-db-evol-opponentId');
		}
		if (sessionStorage.getItem('statelo-db-evol-statsType') !== null) {
			statsType = sessionStorage.getItem('statelo-db-evol-statsType');
		}

    this.setState({loading: true});
		this.loadData(props, chartType, statsType, opponentId, dateA, dateB);
  }

	loadData(props, chartType, statsType, opponentId, dateA, dateB) {
		// console.log('DashMod - loadData');

		// Special feature to prevent data loading with partial dates
		// Date validation.  If dates are not valid, we do not load data
		if (!this.isDateValid(dateA) || !this.isDateValid(dateB) || moment(dateA).isAfter(dateB)) {
			this.setState({
				dateA: dateA,
				dateB: dateB,
			});
			return;
		}

	  var leagueId = props.leagueId;
	  var seasonId = props.seasonId;
    var playerId = props.playerId;
    var resultsType = props.resultsType;
    var leagueType = props.leagueType;

		var _this = this;

		Axios.get('/api/dashmod/evol01/type/' + statsType + 
							'/playerId/' + playerId + '/oppId/' + opponentId + 
							'/year/' + props.year + '/leagueId/' + leagueId +	'/seasonId/' + seasonId +	'/resultsType/' + resultsType + 
							'/leagueType/' + leagueType).then(function(response) {

    	//var opponentValid = false;

    	// console.log('Evol01: response.data');
    	// console.log(response.data);

			var playerData = response.data.playerResults;
			var playerName = response.data.playerInfo.firstname + ' ' + response.data.playerInfo.lastname;

			var opponentData = response.data.opponentResults;
			var opponentName = '(choisir un joueur)';

			if (response.data.opponentInfo !== null) {
				opponentName = response.data.opponentInfo.firstname + ' ' + response.data.opponentInfo.lastname;
			}

			// Set start date on chart
      if (dateA === '') {
				dateA = moment(new Date('2016-01-01')).utc().format("YYYY-MM-DD");
      }
			// Set end date on chart
      if (dateB === '') {
        dateB = moment().utc().format("YYYY-MM-DD");	// today
      }

			_this.setChartData(playerName, playerData, opponentId, opponentName, opponentData, 
				leagueType, chartType, statsType, dateA, dateB, function(chartData, chartOptions) {

					_this.setState({

						playerId: playerId,
						playerData: playerData,
						playerName: playerName,
				
						dateA: dateA,
						dateB: dateB,
						prevValidDateA: dateA,
						prevValidDateB: dateB,

						chartType: chartType,
						opponentId: opponentId,
						opponentName: opponentName,
						statsType: statsType,

						chartData: chartData,
						chartOptions: chartOptions,
						loading: false
					});

					// _this.props.dataIsReady();

					// Save to session storage
					sessionStorage.setItem('statelo-db-evol-dateA', dateA);
					sessionStorage.setItem('statelo-db-evol-dateB', dateB);
					sessionStorage.setItem('statelo-db-evol-chartType', chartType);
					sessionStorage.setItem('statelo-db-evol-opponentId', opponentId);
					sessionStorage.setItem('statelo-db-evol-statsType', statsType);
      });
		});
	}

	setChartData(playerName, playerData, opponentId, opponentName, opponentData, 
		leagueType, chartType, statsType, dateA, dateB, callback) {

		// dataset colors
		const datasetBackgroundColors = ['rgba(0, 120, 225, 0.4)', 'rgba(230, 0, 0, 0.5)'];
		const datasetBorderColors = ['rgba(30, 30, 80, 1)', 'rgba(80, 30, 10, 1)'];
		const datasetHoverBackgroundColors = ['rgba(0, 120, 225, 0.6)', 'rgba(230, 0, 0, 0.7)'];
		const datasetHoverBorderColors = datasetBorderColors;

		// legend colors (overwrite defaults)
		const legendLabelBackgroundColors = datasetBackgroundColors;
		const legendLabelBorderColors = datasetBorderColors;

		var dataArray = [];
		var chartLabels = [];
		var chartDatasets = [];
		var startDate = "";

		var Ymin1 = 99999;
		var Ymax1 = -99999;
		var Ystep1 = 1;

		var chartData = {};
		var chartOptions = {};

		var bFoundAtIdx = -1;

		if (playerData.length !== 0) {

			// One dataset only
			chartDatasets = [
			{
				label: playerName,
			  backgroundColor: datasetBackgroundColors[0],
				borderColor: datasetBorderColors[0],
				borderWidth: 1.5,
				hoverBackgroundColor: datasetHoverBackgroundColors[0],
				hoverBorderColor: datasetHoverBorderColors[0],
				data: [],
				yAxisID: 'y-axis-1',
				fill: false,
				pointRadius: 3,
      	pointHitRadius: 4,
      	pointHoverRadius: 4,
			},
			{
				label: opponentName,
		    backgroundColor: datasetBackgroundColors[1],
				borderColor: datasetBorderColors[1],
				borderWidth: 1.5,
				hoverBackgroundColor: datasetHoverBackgroundColors[1],
				hoverBorderColor: datasetHoverBorderColors[1],
				data: [],
				yAxisID: 'y-axis-1',
				fill: false,
				pointRadius: 3,
      	pointHitRadius: 4,
      	pointHoverRadius: 4,
			}];

			var stats1 = [];
			for (var idx = 0; idx < playerData.length; idx++) {
				switch(chartType) {
				case 0: 
					stats1.push(playerData[idx].moy);
					if(leagueType === myConstClass.LGTYPE_10B) {
						Ymin1 = 0; Ymax1 = 100; Ystep1 = 20;
					} else {
						Ymin1 = 0; Ymax1 = 12; Ystep1 = 2;
					}
					break;
				case 1: 
					stats1.push(playerData[idx].ips);
					Ymin1 = 0; Ymax1 = 1000; Ystep1 = 200;
					break;
				case 2: 
					stats1.push(playerData[idx].pctWin);
					Ymin1 = 0; Ymax1 = 100; Ystep1 = 20;
					break;
				case 3: 
					stats1.push(playerData[idx].fp);
					Ymin1 = 0; Ymax1 = 12; Ystep1 = 2;
					break;
				}
			}
			var stats2 = [];
			for (var idx = 0; idx < opponentData.length; idx++) {
				switch(chartType) {
				case 0: 
					stats2.push(opponentData[idx].moy);
					if(leagueType === myConstClass.LGTYPE_10B) {
						Ymin1 = 0; Ymax1 = 100; Ystep1 = 20;
					} else {
						Ymin1 = 0; Ymax1 = 12; Ystep1 = 2;
					}
					break;
				case 1: 
					stats2.push(opponentData[idx].ips);
					Ymin1 = 0; Ymax1 = 1000; Ystep1 = 200;
					break;
				case 2: 
					stats2.push(opponentData[idx].pctWin);
					Ymin1 = 0; Ymax1 = 100; Ystep1 = 20;
					break;
				case 3: 
					stats2.push(opponentData[idx].fp);
					Ymin1 = 0; Ymax1 = 12; Ystep1 = 2;
					break;
				}
			}

			// -----------------------------------------------------
			// Fill out chart data table
			var compUnitsString = 'day';
			switch(statsType) {

				case 'daily': 
					compUnitsString = 'day';

					// Parse results to fill chart data
					for (var idx = 0; idx < playerData.length; idx++) {
						startDate = moment(playerData[idx].date).utc().format("YYYY-MM-DD");
						dataArray.push([startDate, stats1[idx], null]);
					}
					for (var idx = 0; idx < opponentData.length; idx++) {
						startDate = moment(opponentData[idx].date).utc().format("YYYY-MM-DD");
						dataArray.push([startDate, null, stats2[idx]]);
					}
					break;

				case 'weekly': 
					compUnitsString = 'week';

					// Parse results to fill chart data
					for (var idx = 0; idx < playerData.length; idx++) {
						startDate = this.convWeekNoToDate(playerData[idx].year, playerData[idx].weekNo);
						dataArray.push([startDate, stats1[idx], null]);
					}
					for (var idx = 0; idx < opponentData.length; idx++) {
						startDate = this.convWeekNoToDate(opponentData[idx].year, opponentData[idx].weekNo);
						dataArray.push([startDate, null, stats2[idx]]);
					}
					break;
			
				case 'monthly': 
					compUnitsString = 'month';

					// Parse results to fill chart data
					for (var idx = 0; idx < playerData.length; idx++) {
						startDate = this.convMonthNoToDate(playerData[idx].year, playerData[idx].monthNo);
						dataArray.push([startDate, stats1[idx], null]);
					}
					for (var idx = 0; idx < opponentData.length; idx++) {
						startDate = this.convMonthNoToDate(opponentData[idx].year, opponentData[idx].monthNo);
						dataArray.push([startDate, null, stats2[idx]]);
					}
					break;

				case 'yearly': 
					compUnitsString = 'year';

					// Parse results to fill chart data
					for (var idx = 0; idx < playerData.length; idx++) {
						startDate = moment(new Date(playerData[idx].year, 0, 1)).utc().format("YYYY");
						dataArray.push([startDate, stats1[idx], null]);
					}
					for (var idx = 0; idx < opponentData.length; idx++) {
						startDate = moment(new Date(opponentData[idx].year, 0, 1)).utc().format("YYYY");
						dataArray.push([startDate, null, stats2[idx]]);
					}
					break;
			}

			// Sort data
			dataArray.sort(function(a, b) {
				return(new Date(a[0]) - new Date(b[0]));
			});

			// Remove Extra data
			for (var idx = dataArray.length-2; idx >= 0; idx--) {
				if (dataArray[idx][0] === dataArray[idx+1][0]) {
					if (dataArray[idx][1] === null) {
						dataArray[idx][1] = dataArray[idx+1][1];
					}
					if (dataArray[idx][2] === null) {
						dataArray[idx][2] = dataArray[idx+1][2];
					}
					dataArray.splice(idx+1, 1);
				}
			}

			// Set chart data
			// Filter by dates (convert with moment)
			dataArray = dataArray.filter(function(a) {

			switch(statsType) {
				case 'daily': 
				case 'monthly': 
				case 'weekly': 
					// these types compares directly
					var compDataValue = moment(new Date(a[0], 0, 1)).format("YYYY-MM-DD");
					return (( moment(a[0]).isSameOrAfter(moment(dateA), compUnitsString)) && 
						( moment(a[0]).isSameOrBefore(moment(dateB), compUnitsString)) );
					break;

				case 'yearly': 
					// get date from 'year' for comparison
					var compDataValue = moment(new Date(a[0], 0, 1)).format("YYYY-MM-DD");
					return (( moment(compDataValue).isSameOrAfter(moment(dateA), compUnitsString)) && 
						( moment(compDataValue).isSameOrBefore(moment(dateB), compUnitsString)) );
					break;
				}
			});

			chartLabels = dataArray.map(function(value, index) { return value[0]; });
			chartDatasets[0].data = dataArray.map(function(value, index) { return value[1]; });
			chartDatasets[1].data = dataArray.map(function(value, index) { return value[2]; });

			// Set chart parameters
			chartData = {
				labels: chartLabels,
				datasets: chartDatasets
			};

			// use generateLabels function to overwrite background colors in legend
			// Since last version of chart.js, background colors of legend labels were set like
			// the fill=false option of the chartDatasets, so no fill means no legend label background, resulting
			// in an ugly filled rectangle.  This function overwrites this behaviour and sets the label background 
			// color to something different and nicer
			// ref:  https://stackoverflow.com/questions/60530818/chart-js-can-you-override-the-legend-label-box-color
			chartOptions = {
			  legend: {
			    display: true,
			    labels: {
			      generateLabels: function(chart) {
			        let labels = Chart.defaults.global.legend.labels.generateLabels(chart);
			        for (var key in labels) {
			          labels[key].fillStyle = legendLabelBackgroundColors[key];
			          labels[key].strokeStyle = legendLabelBorderColors[key]; 
			        }
			        return labels;
			      }
			    }
			  },

				maintainAspectRatio: false,
				/*height: 1200,*/
				spanGaps: true,

				scales: {
					yAxes: [{
	          id: 'y-axis-1',
	          type: 'linear',
	          position: 'left',
	          ticks: {
              suggestedMin: Ymin1,
              suggestedMax: Ymax1,
	        		stepSize: Ystep1
          	}
			    }]
	  		}
			};
		}

		callback(chartData, chartOptions);
	}

	render() {
		// console.log('DashMod_Evol01: render');
		// console.log(this.state.playerData);
		return (
			<div className="row db-module-outer-dark">
			<div className="col-12">

				<div className="row">
				<div className="col-12 text-center">
					<h4 className="db-module-title-dark">Votre évolution</h4>
				</div>
				</div>
	
				<div className="row db-module-inner-dark">
				<div className="col-md-12 db-module-inner-col-padding">
				<div className="card db-module-inner-card-dark-chart">
					{this.state.loading ? 
						<div className="text-center margin-top-10">
							<i> données en chargement </i>
							{this.displaySpinner()}
						</div> 
						: this.dispModules()
					}
				</div>
				</div>
				</div>

			</div>
			</div>
		)
	}

	dispModules() {
		var txtHeader1 = CST_CHART_TYPES[this.state.chartType];
		var txtHeader2 = 'par JOUR';
		if (this.state.statsType === 'weekly') {
			txtHeader2 = 'par SEMAINE';
		}
		if (this.state.statsType === 'monthly') {
			txtHeader2 = 'par MOIS';
		}
		if (this.state.statsType === 'yearly') {
			txtHeader2 = 'par ANNÉE';
		}

		return (
			<div>
				<div className="card-header">
					<i className="fa fa-line-chart"></i>
       		<span className="text-uppercase font-weight-bold">ÉVOLUTION - {txtHeader1} - {txtHeader2}</span>
				</div>

				<div className="card-block card-body">
					{this.displayData()}
				</div>
			</div>
		)
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
		);
	}

	displayData() {
		// predefined buttons text
		var predefinedButtonText1 = '';
		switch(this.state.statsType) {
		case 'daily':
			predefinedButtonText1 = '30 derniers jours';
			break;
		case 'weekly':
			predefinedButtonText1 = '6 derniers mois';
			break;
		case 'monthly':
			predefinedButtonText1 = 'dernière année';
			break;
		case 'yearly':
			break;
		}

		if (this.state.playerData.length !== 0) {
			return (
				<div className="row">
					{/* left pane */}
					<div className="col-md-9 chart-wrapper" style={{height: CST_CHART_HEIGHT}} >
						<Line data={this.state.chartData} options={this.state.chartOptions} />
					</div>
          {/* end of pane */}

					{/* right pane */}
					<div className="col-md-3">

						{/* Display statsType selector */}

		        <div className="row row-margin-bottom-5">
						<div className="col-12">
							<strong>Filtres du graphique</strong>
						</div>
						</div>

		        <div className="row row-margin-bottom-5">
						<div className="col-12">
							<span className="small">Périodes</span>
				  		<select className="form-control form-control-sm input-sm" type="text" id="sel1" value={this.state.statsType} 
				  				onChange={this.handleSelStatsTypeChange}>
				      	<option value='daily' key='opt0'>jour</option>
				        <option value='weekly' key='opt1'>semaine</option>
				        <option value='monthly' key='opt2'>mois</option>
								<option value='yearly' key='opt3'>année</option>
							</select>
						</div>
						</div>

		        <div className="row row-margin-bottom-5">
						<div className="col-12">
							<span className="small">Date de début</span><br/>
							<input type="date" className="form-control form-control-sm input-sm" name="dateA" id="dateA" 
								value={this.state.dateA || ''} onChange={this.handleDateAChange} onBlur={this.handleDateABlur}/>
						</div>
						</div>

		        <div className="row row-margin-bottom-10">
						<div className="col-12">
							<span className="small">Date de fin</span><br/>
							<input type="date" className="form-control form-control-sm input-sm" name="dateB" id="dateB"
								value={this.state.dateB || ''} onChange={this.handleDateBChange} onBlur={this.handleDateBBlur}/>
						</div>
						</div>

		        <div className="row">
						<div className="col-12">
							{(this.state.statsType !== 'yearly') ?
								<button className="btn btn-sm btn-primary btn-evol1-width" onClick={this.handleEvolPredefined.bind(this, 0)}>
									{predefinedButtonText1}
								</button>
							: null}
							<button className="btn btn-sm btn-primary btn-evol2-width" onClick={this.handleEvolPredefined.bind(this, 1)}>
								à vie
							</button>
						</div>
            </div>

						{/* Display statsType selector */}
		        <div className="row row-margin-bottom-5">
						<div className="col-12">
							<span className="small">Type</span>
				  		<select className="form-control form-control-sm input-sm" type="text" id="sel1" value={this.state.chartType}
				  				onChange={this.handleSelchartTypeChange}>
				        <option value='0' key='opt0'>Moyenne</option>
				        <option value='1' key='opt1'>IPS</option>
				        <option value='2' key='opt2'>% de victoires</option>
							</select>
						</div>
						</div>

		        <div className="row row-margin-bottom-5">
						<div className="col-12">
							<span className="small">Comparer à</span>
							<AutoSuggestPlayer playerId={this.state.opponentId} dataChange={this.handleOpponentChange} />
						</div>
						</div>

            </div>	
            {/* end of pane */}
					</div>
			);
			
		} else {
			return (
				<div>
					Aucune donnée
	      </div>
			);
		}
	}

	handleOpponentChange(dataValue) {
		var opponentId = dataValue;
		this.loadData(this.props, this.state.chartType, this.state.statsType, opponentId, this.state.dateA, this.state.dateB)
	}

	handleSelStatsTypeChange(e) {
		var statsType = e.target.value;
		this.loadData(this.props, this.state.chartType, statsType, this.state.opponentId, this.state.dateA, this.state.dateB)
	}

	handleSelchartTypeChange(e) {
		var chartType = parseInt(e.target.value, 10);
		this.loadData(this.props, chartType, this.state.statsType, this.state.opponentId, this.state.dateA, this.state.dateB)
	}

	handleDateAChange(e) {
		var dateA = e.target.value;
		this.loadData(this.props, this.state.chartType, this.state.statsType, this.state.opponentId, dateA, this.state.dateB)
	}
	handleDateBChange(e) {
		var dateB = e.target.value;	
		this.loadData(this.props, this.state.chartType, this.state.statsType, this.state.opponentId, this.state.dateA, dateB)
	}
	handleDateABlur(e) {
		var newDateA = e.target.value;
		if (!this.isDateValid(newDateA) || moment(newDateA).isAfter(this.state.dateB)) {
			this.setState({dateA: this.state.prevValidDateA});
		}
	}
	handleDateBBlur(e) {
		var newDateB = e.target.value;
		if (!this.isDateValid(newDateB) || moment(newDateB).isBefore(this.state.dateA)) {
			this.setState({dateB: this.state.prevValidDateB});
		}
	}

	handleEvolPredefined(btnIdx, e) {
		// Init dates for "à vie" stats
		var dateA = moment(new Date('2016-01-01')).utc().format("YYYY-MM-DD");
		var dateB = moment(new Date()).utc().format("YYYY-MM-DD");

		if (btnIdx === 0) {
			switch (this.state.statsType) {
			case 'daily': 
				dateA = moment(dateB).subtract(30, 'days').utc().format("YYYY-MM-DD");
				break;
			case 'weekly': 
				dateA = moment(dateB).subtract(6, 'months').utc().format("YYYY-MM-DD");
				break;
			case 'monthly': 
				dateA = moment(dateB).subtract(12, 'months').utc().format("YYYY-MM-DD");
				break;
			case 'daily': 
				break;
			}
		}

		this.loadData(this.props, this.state.chartType, this.state.statsType, this.state.opponentId, dateA, dateB);
	}

	convWeekNoToDate(year, week) {
		return (moment().year(year).week(week).day("sunday").format('YYYY-MM-DD'));
	}

	convMonthNoToDate(year, month) {
		return (moment().year(year).month(month-1).startOf('month').format('YYYY-MM'));
	}

	isDateValid(dateVal) {
		var dateIsValid = false;
		var minValidDate = moment(new Date("2001-01-01"));
		var maxValidDate = moment(new Date("2199-12-31"));
		if ((dateVal === '') || (
			  moment(new Date(dateVal)).isSameOrAfter(minValidDate) && 
				moment(new Date(dateVal)).isSameOrBefore(maxValidDate))) {

			dateIsValid = true;
		}
		return dateIsValid;
	}

}

export default DashMod_Evol01;
